export default __webpack_public_path__ + "static/32-be04b55da03ff9e1e4f5eefc5d5b6238.png";